import { useEffect, useState, useRef } from 'react';
import {
  NavLink,
  useLocation,
  useParams
} from 'react-router-dom';
import { reaction, } from 'mobx';
import { getCountWithPathname } from './CountLabelValue';

function NavList(props) {
  const [countObject, setCountObject] = useState({});
  const activeStyle = {
    borderBottom: '2px solid #7434fe',
    color: '#7434fe',
  };
  const location = useLocation();
  const params = useParams();
  const pathName = location.pathname || '';
  const mounted = useRef();

  const licensePath = `/results/license/binary/${params.idReport}`;
  const litigatorPath = `/results/license/litigator/${params.idReport}`;

  const securityPath = `/results/security/binary/${params.idReport}`;
  const cnvdPath = `/results/security/cnvd/${params.idReport}`;

  const {
    state,
    scannedFileCount,
    totalCount,
    translate,
  } = props;
  const object = getCountWithPathname(pathName, state, params);

  useEffect(() => {
    const disposers = [];
    if (!mounted.current) {
      disposers.push(
        reaction(
          () => {
            const obj = getCountWithPathname(pathName, state, params);
            return obj;
          },
          (obj) => {
            setCountObject(obj);
          },
        )
      );
    }

    return () => {
      disposers.forEach((disposer) => {
        disposer();
      });
    };
  }, [location, params, pathName, state]);

  if (pathName.indexOf('overview') !== -1 && pathName.indexOf(params.idReport) === -1) {
    const isActiveFiles = pathName === '/results/overview';
    const isActiveProjects = pathName === '/results/overview/project';
    const isActiveIssues = pathName === '/results/overview/issue';

    return (
      <div className="contents_tab">
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/overview"
          end
        >
          {translate('contents_header.link_header.files')}
          <em>{isActiveFiles ? totalCount : (countObject.reportCount || object.reportCount)}</em>
        </NavLink>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/overview/project"
          end
        >
          {translate('contents_header.link_header.projects')}
          <em>{isActiveProjects ? totalCount : (countObject.projectCount || object.projectCount)}</em>
        </NavLink>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/overview/issue"
          end
        >
          {translate('contents_header.link_header.issues')}
          <em>{isActiveIssues ? totalCount : (countObject.issueCount || object.issueCount)}</em>
        </NavLink>
      </div>
    );
  }

  if (pathName.indexOf('overview') !== -1 && pathName.indexOf(params.idReport) !== -1) {
    return (
      <h3 className="content_title">
        {translate('contents_header.link_header.scanned_files')}
        <em>{scannedFileCount}</em>
      </h3>
    );
  }

  if (pathName.indexOf('component') !== -1 && pathName.indexOf(params.idReport) === -1) {
    const isActiveComponents = pathName === '/results/component';
    const isActiveProjectComponents = pathName === '/results/component/project';

    return (
      <div className="contents_tab">
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/component"
          end
        >
          {translate('contents_header.link_header.components')}
          <em>
            {isActiveComponents
              ? totalCount
              : (countObject.componentCount && countObject.componentCount.total) || (object.componentCount && object.componentCount.total)}
          </em>
        </NavLink>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/component/project"
          end
        >
          {translate('contents_header.link_header.projects')}
          <em>
            {isActiveProjectComponents
              ? totalCount
              : (countObject.projectCount && countObject.projectCount) || (object.projectCount && object.projectCount)}
          </em>
        </NavLink>
      </div>
    );
  }

  if (pathName.indexOf('component') !== -1 && pathName.indexOf(params.idReport) !== -1) {
    return (
      <h3 className="content_title">
        {translate('contents_header.link_header.component_list')}
        <em>{totalCount}</em>
      </h3>
    );
  }

  if (pathName.indexOf('security') !== -1 && pathName.indexOf(params.idReport) === -1) {
    const isActiveSecurity = pathName === '/results/security';
    const isActiveProjectSecurity = pathName === '/results/security/project';

    return (
      <div className="contents_tab">
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/security"
          end
        >
          {translate('contents_header.link_header.security_risks')}
          <em>
            {isActiveSecurity
              ? totalCount
              : (countObject.securityCount && countObject.securityCount.total) || (object.securityCount && object.securityCount.total)}
          </em>
        </NavLink>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/security/project"
          end
        >
          {translate('contents_header.link_header.projects')}
          <em>
            {isActiveProjectSecurity
              ? totalCount
              : (countObject.projectCount) || (object.projectCount)}
          </em>
        </NavLink>
      </div>
    );
  }

  if (pathName.indexOf('security') !== -1 && pathName.indexOf(params.idReport) !== -1) {
    const isActiveSecurityList = pathName === securityPath;
    const isActiveCNVDList = pathName === cnvdPath;

    return (
      <div className="contents_tab" style={{ display: 'block' }}>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to={securityPath}
        >
          {translate('contents_header.link_header.security_risk_list')}
          <em>
            {isActiveSecurityList
              ? totalCount
              : (countObject.securityCount && countObject.securityCount.total) || (object.securityCount && object.securityCount.total)}
          </em>
        </NavLink>
        {(countObject.cnvdCount && countObject.cnvdCount === 0) || (object.cnvdCount && object.cnvdCount === 0) ? (
          <NavLink
            style={{ pointerEvents: 'none' }}
          >
            {translate('contents_header.link_header.cnvd_list')}
            <em>0</em>
          </NavLink>
        ) : (
          <NavLink
            style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
            to={cnvdPath}
          >
            {translate('contents_header.link_header.cnvd_list')}
            <em>
              {isActiveCNVDList
                ? totalCount || 0
                : countObject.cnvdCount || object.cnvdCount || 0}
            </em>
          </NavLink>
        )}
      </div>
    );
  }

  if (pathName.indexOf('license') !== -1 && pathName.indexOf(params.idReport) === -1) {
    const isActiveLicenses = pathName === '/results/license';
    const isActiveLitigators = pathName === '/results/license/litigator';
    const isActiveProjectLicenses = pathName === '/results/license/project';

    return (
      <div className="contents_tab">
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/license"
          end
        >
          {translate('contents_header.link_header.licenses')}
          <em>
            {isActiveLicenses
              ? totalCount
              : (countObject.licenseCount && countObject.licenseCount.total) || (object.licenseCount && object.licenseCount.total)}
          </em>
        </NavLink>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/license/litigator"
          end
        >
          {translate('contents_header.link_header.litigators')}
          <em>
            {isActiveLitigators
              ? totalCount
              : countObject.litigatorCount || object.litigatorCount}
          </em>
        </NavLink>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/license/project"
          end
        >
          {translate('contents_header.link_header.projects')}
          <em>
            {isActiveProjectLicenses
              ? totalCount
              : countObject.projectCount || object.projectCount}
          </em>
        </NavLink>
      </div>
    );
  }

  if (pathName.indexOf('license') !== -1 && pathName.indexOf(params.idReport) !== -1) {
    const isActiveLicenseList = pathName === licensePath;
    const isActiveLitigatorList = pathName === litigatorPath;

    return (
      <div className="contents_tab" style={{ display: 'block' }}>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to={licensePath}
        >
          {translate('contents_header.link_header.license_list')}
          <em>
            {isActiveLicenseList
              ? totalCount
              : (countObject.licenseCount && countObject.licenseCount.total) || (object.licenseCount && object.licenseCount.total)}
          </em>
        </NavLink>
        {(countObject.litigatorCount && countObject.litigatorCount === 0) || (object.litigatorCount && object.litigatorCount === 0) ? (
          <NavLink
            style={{ pointerEvents: 'none' }}
          >
            {translate('contents_header.link_header.litigator_list')}
            <em>0</em>
          </NavLink>
        ) : (
          <NavLink
            style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
            to={litigatorPath}
          >
            {translate('contents_header.link_header.litigator_list')}
            <em>
              {isActiveLitigatorList
                ? totalCount
                : countObject.litigatorCount || object.litigatorCount}
            </em>
          </NavLink>
        )}
      </div>
    );
  }

  if (pathName.indexOf('policy') !== -1 && pathName.indexOf(params.idReport) === -1) {
    const isActivePolicy = pathName === '/results/policy';
    const isActivePolicyProject = pathName === '/results/policy/project';

    return (
      <div className="contents_tab">
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/policy"
          end
        >
          {translate('contents_header.link_header.policy')}
          <em>
            {isActivePolicy
              ? totalCount
              : (countObject.policyCount && countObject.policyCount.total) || (object.policyCount && object.policyCount.total)}
          </em>
        </NavLink>
        <NavLink
          style={({ isActive }) => { return (isActive ? activeStyle : undefined); }}
          to="/results/policy/project"
          end
        >
          {translate('contents_header.link_header.projects')}
          <em>
            {isActivePolicyProject
              ? totalCount
              : countObject.projectCount || object.projectCount}
          </em>
        </NavLink>
      </div>
    );
  }

  if (pathName.indexOf('policy/project') !== -1 && pathName.indexOf(params.idReport) !== -1) {
    return (
      <h3 className="content_title">
        {translate('contents_header.link_header.violated_policy_list')}
        <em>{totalCount}</em>
      </h3>
    );
  }

  if (pathName.indexOf('policy/binary') !== -1 && pathName.indexOf(params.idReport) !== -1) {
    return (
      <h3 className="content_title">
        {translate('contents_header.link_header.revision_list')}
        <em>{totalCount}</em>
      </h3>
    );
  }
}
export default NavList;
